import React, { Fragment } from 'preact/compat';
import { Field } from 'formik';
import { useSelfServiceFormContext } from './context';
import AttachmentQueue from '../attachments/queue';
import { ProductMenuOptions } from './common';
import Dialog, { useDialog } from '../../overlay/dialog';
import FormLabel from '../label';
import FormHelp from '../help';
import FormError from '../error';

export default function ProductProblemFields() {
    const [isDialogShown, showDialog, hideDialog] = useDialog();
    const {
        products,
        classNames,
        images: {
            code: codeImage,
        },
    } = useSelfServiceFormContext();

    return (
        <Fragment>
            <div className='form__grid'>
                <div className='form__grid-item  form__field'>
                    <FormLabel htmlFor='problemProduct' required={true}>Choose a product</FormLabel>
                    <Field as='select' name='productProblem.product' id='problemProduct' className='input  input--select'>
                        <option />
                        <ProductMenuOptions options={products} />
                    </Field>
                    <FormError name='productProblem.product' />
                </div>
                <div className='form__grid-item  form__grid-item--wide  form__field'>
                    <FormLabel htmlFor='batchCode' required={true}>Please enter the batch code, date and time from the lid</FormLabel>
                    <FormHelp>
                        It is really important you provide us with ALL the details from the lid of your product, all the codes and the date when shown.{' '}
                        <button type='button' onClick={showDialog} className='button-link'>
                            Where do I find my date and codes?
                        </button>
                    </FormHelp>
                    <Field name='productProblem.batchCode' id='batchCode' maxLength={50} className='input  input--text' />
                    <FormError name='productProblem.batchCode' />
                </div>
                <div className='form__grid-item  form__grid-item--wide  form__field'>
                    <FormLabel htmlFor='productProblem' required={true}>Please tell us about the problem</FormLabel>
                    <FormHelp>
                        <p>So that we can help you, we would appreciate as much detail as possible including photographs:</p>
                        <ul>
                            <li>all of the details from the lid of your product as shown above</li>
                            <li>where and when purchased</li>
                            <li>when you first opened your product</li>
                        </ul>
                        <p><strong>Please note:</strong> we are sorry, but without the product and packaging, it may not be practical to look into your enquiry so please do retain them until we have responded to you.</p>
                    </FormHelp>
                    <Field as='textarea' name='productProblem.problem' id='productProblem' className='input  input--textarea' />
                    <FormError name='productProblem.problem' />
                </div>
                <div className='form__grid-item  form__grid-item--wide  form__field'>
                    <AttachmentQueue
                        name='attachments'
                        id='attachments'
                        mimeTypes={['image/*']}
                        maxCount={3}
                        help='JPG, PNG or GIF; up to 10 MB'
                    />
                    <FormError name='attachments' />
                </div>
                <div className='form__grid-item  form__grid-item--wide'>
                    <a href='#contact-fields' className={classNames.button.submit}>
                        Continue
                    </a>
                </div>
            </div>
            <Dialog
                titleId='wheres-my-code-heading'
                shown={isDialogShown}
                close={hideDialog}>
                <Dialog.Heading id='wheres-my-code-heading' className={classNames.heading}>
                    Where’s my code?
                </Dialog.Heading>
                <div className='type  type--center'>
                    <img src={codeImage} alt='The best before date and product code are found on the top of the lid or the back of the pack' />
                </div>
                <Dialog.Footer>
                    <button type='button' onClick={hideDialog} className={classNames.button.close}>
                        Close
                    </button>
                </Dialog.Footer>
            </Dialog>
        </Fragment>
    );
}
